"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _VariationSelector = require("./components/VariationSelector");

var _VariationSelector2 = _interopRequireDefault(_VariationSelector);

var _xstate = require("xstate");

var _interpreter = require("xstate/lib/interpreter");

var _objectHash = require("object-hash");

var _objectHash2 = _interopRequireDefault(_objectHash);

require("./global.css");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      _defineProperty(target, key, source[key]);
    });
  }

  return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}
/**
 * Display a list of SKU items of a product and its specifications.
 */


var SKUSelector = /*#__PURE__*/function (_PureComponent) {
  _inherits(SKUSelector, _PureComponent);

  function SKUSelector(props) {
    var _this;

    _classCallCheck(this, SKUSelector);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(SKUSelector).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "handleStateTransition", function (state) {
      var stateMachineStateHash = state.value;
      var onChange = _this.props.onChange;

      _this.setState({
        stateMachineStateHash: stateMachineStateHash
      });

      var stateMachineState = _this.stateMachine.states[stateMachineStateHash];
      var selectedVariations = stateMachineState.variations;
      var sku = stateMachineState.sku,
          price = stateMachineState.price;
      var allVariationsSelected = Object.keys(selectedVariations).reduce(function (accumulator, variation) {
        return accumulator && selectedVariations[variation] !== null;
      }, true);
      onChange({
        sku: sku,
        allVariationsSelected: allVariationsSelected,
        selectedVariations: selectedVariations,
        price: price
      });
    });

    _defineProperty(_assertThisInitialized(_this), "getDifferentVariation", function (stateA, stateB) {
      var counter = 0;
      var differentVariation = null;
      Object.keys(stateA).forEach(function (variation) {
        if (stateA[variation] !== stateB[variation]) {
          counter++;
          differentVariation = variation;
        }
      });
      if (counter === 1) return differentVariation;
    });

    _defineProperty(_assertThisInitialized(_this), "createStateMachine", function (skus, visualVariations, standardVariations, initialState) {
      var _assertThisInitialize = _assertThisInitialized(_this),
          stateMachine = _assertThisInitialize.stateMachine;

      stateMachine.id = 'SKUSelector';
      stateMachine.states = {};
      stateMachine.transitions = {};
      var states = stateMachine.states,
          transitions = stateMachine.transitions;
      skus.forEach(function (sku) {
        /** Creates all possible states without selecting some standardVariations **/
        var bitMaskLimit = 1 << standardVariations.length;

        var _loop = function _loop(bitMask) {
          var state = {
            variations: {}
          };
          visualVariations.forEach(function (variation) {
            return state.variations[variation] = sku[variation];
          });
          standardVariations.forEach(function (variation, variationIndex) {
            if (1 << variationIndex & bitMask) state.variations[variation] = sku[variation];else state.variations[variation] = null;
          });
          var stateKey = (0, _objectHash2["default"])(state.variations);
          if (bitMask === 0 && !stateMachine.initial) stateMachine.initial = stateKey;

          if (!states[stateKey] || !states[stateKey].available) {
            if (!states[stateKey]) states[stateKey] = {};
            states[stateKey].variations = state.variations;
            states[stateKey].sku = sku.sku;
            states[stateKey].available = sku.available;
          }

          if (sku.available) {
            if (states[stateKey].price) {
              var _states$stateKey$pric = states[stateKey].price,
                  value = _states$stateKey$pric.value,
                  notUnique = _states$stateKey$pric.notUnique;
              states[stateKey].price.notUnique = notUnique || sku.price.notUnique || sku.price.value !== value;
              states[stateKey].price.value = Math.min(value, sku.price.value);
            } else states[stateKey].price = _objectSpread({}, sku.price);
          }
        };

        for (var bitMask = 0; bitMask < bitMaskLimit; bitMask++) {
          _loop(bitMask);
        }
      });
      /** Creates a transition from A to B if there is only one different variation **/

      Object.keys(states).forEach(function (keyA) {
        states[keyA].on = {};
        Object.keys(states).forEach(function (keyB) {
          var stateA = states[keyA].variations;
          var stateB = states[keyB].variations;

          var differentVariation = _this.getDifferentVariation(stateA, stateB);

          if (!differentVariation) return;
          var action = {
            variation: differentVariation,
            label: stateB[differentVariation]
          };
          var actionHash = (0, _objectHash2["default"])(action);
          transitions[actionHash] = action;
          states[keyA].on[actionHash] = keyB;
        });
      });
      if (initialState && stateMachine.states[initialState]) stateMachine.initial = initialState;
      return (0, _xstate.Machine)(stateMachine);
    });

    _defineProperty(_assertThisInitialized(_this), "onSelectItem", function (actionHash) {
      return function () {
        _this.stateMachine.interpret.send(actionHash);
      };
    });

    _this.state = {};
    _this.visualVariations = [];
    _this.standardVariations = [];
    _this.stateMachine = {};
    _this.variationsOptions = {};
    return _this;
  }

  _createClass(SKUSelector, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      var _this$props = this.props,
          skus = _this$props.skus,
          variations = _this$props.variations,
          selectedVariations = _this$props.selectedVariations;
      if (!variations || !variations.length) return;
      variations.forEach(function (variation) {
        /** Separate all variations into visualVariations and standardVariations based on the thumbSrc value */
        if (variation.hasThumbs) _this2.visualVariations.push(variation.name);else _this2.standardVariations.push(variation.name);
        /** Fills variationsOptions with all possible variationOptions */

        _this2.variationsOptions[variation.name] = {};
        skus.forEach(function (sku) {
          _this2.variationsOptions[variation.name][sku[variation.name]] = true;
        });
      });
      this.stateMachine.interpret = (0, _interpreter.interpret)(this.createStateMachine(skus, this.visualVariations, this.standardVariations, selectedVariations && (0, _objectHash2["default"])(selectedVariations)));
      this.setState({
        stateMachineStateHash: this.stateMachine.initial
      });
      this.stateMachine.interpret.onTransition(this.handleStateTransition).start();
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      if (!this.props.variations || !this.props.variations.length) return null;
      var visualVariations = this.visualVariations,
          standardVariations = this.standardVariations;
      var _this$props2 = this.props,
          askToSelectVariations = _this$props2.askToSelectVariations,
          designTokens = _this$props2.designTokens;
      var variations = visualVariations.concat(standardVariations);
      var stateMachineStateHash = this.state.stateMachineStateHash;
      if (!stateMachineStateHash) return _react2["default"].createElement("div", null);
      var stateMachineStates = this.stateMachine.states;
      var stateMachineState = stateMachineStates[stateMachineStateHash];
      var transitions = stateMachineState.on;
      var selectedVariations = stateMachineState.variations;
      return _react2["default"].createElement(_react2["default"].Fragment, null, variations.map(function (variation, variationIndex) {
        var selectedItem = selectedVariations[variation];
        var items = Object.keys(_this3.variationsOptions[variation]).reduce(function (accumulator, label) {
          var selected = selectedItem === label;
          var actionHash = (0, _objectHash2["default"])({
            variation: variation,
            label: selected ? null : label
          });
          var nextStateHash = transitions[actionHash];

          if (nextStateHash || selected) {
            var available = selected ? stateMachineState.available : stateMachineStates[nextStateHash].available;
            accumulator.push({
              label: label,
              available: available,
              thumbSrc: null,
              onSelectItem: _this3.onSelectItem(actionHash)
            });
          }

          return accumulator;
        }, []);
        return _react2["default"].createElement(_VariationSelector2["default"], {
          key: variationIndex,
          variation: {
            name: variation,
            items: items
          },
          designTokens: designTokens,
          selectedItem: selectedItem,
          askToSelectVariation: askToSelectVariations && !selectedItem
        });
      }));
    }
  }]);

  return SKUSelector;
}(_react.PureComponent);

SKUSelector.propTypes = {
  /** Variation name, the same used as key in 'skus' */
  variations: _propTypes2["default"].arrayOf(_propTypes2["default"].shape({
    name: _propTypes2["default"].string,
    hasThumbs: _propTypes2["default"].bool
  })),

  /** Can just pass vtex product.items */
  skus: _propTypes2["default"].arrayOf(_propTypes2["default"].shape({
    /** Value that will be returned when selected */
    sku: _propTypes2["default"].any,

    /** True if it's available, available quantity > 0 */
    available: _propTypes2["default"].bool,

    /** Necessary for the component return the minimum price at each state */
    price: _propTypes2["default"].shape({
      /** The minimum price of that Sku */
      value: _propTypes2["default"].number,

      /** True if this sku have different prices from multiple sellers */
      notUnique: _propTypes2["default"].bool
    })
    /** Also has the values for each variation as variationName: label */

  })),

  /** selectedVariations in the initial state of the form {variationName: label}
   *  for all variations using null if it's not selected */
  selectedVariations: _propTypes2["default"].object,

  /** Function called when the state change is triggered. It receives the selected sku,
   *  the variations that are selected and a boolean telling if all variations are selected  */
  onChange: _propTypes2["default"].func,

  /** Boolean prop that displays a warning text beside not selected variations */
  askToSelectVariations: _propTypes2["default"].bool,

  /** Used to change internal designs. When set, will replace component className **/
  designTokens: _propTypes2["default"].shape({
    skuSelectorContainer: _propTypes2["default"].string
  })
};
exports["default"] = SKUSelector;